import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <g fill="currentColor">
    <path d="M3 13h2v-2H3zm4 8h2v-2H7zm-4 0h2v-2H3zM3 9h2V7H3zm0-4h2V3H3zm10-2h-2v2h2zM3 17h2v-2H3zM9 3H7v2h2zm2 18h2v-2h-2zm8-8h2v-2h-2zm0-4h2V7h-2zm0-4h2V3h-2zm-4 0h2V3h-2z" />
    <path
      stroke="#666"
      strokeWidth=".5"
      d="M12.582 12.0034a.478.478 0 0 0-.3493.2153.479.479 0 0 0-.0536.4072l3.0245 9.2433a.478.478 0 0 0 .451.3282.478.478 0 0 0 .4544-.3232l1.5123-4.542 5.0044-1.3646a.4782.4782 0 0 0 .0149-.9164l-9.8696-3.028a.48.48 0 0 0-.189-.0197Zm.786 1.2002 7.422 2.276-3.6662 1.001a.478.478 0 0 0-.3283.3088l-1.1342 3.4114z"
    />
  </g>,
  'SelectAoi',
);
